/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var brightsmith_core_1 = require("brightsmith-core");

var Helper = {
  getFullImageUrl: function getFullImageUrl(img, baseUrl) {
    return brightsmith_core_1.Util.cleanUrl("".concat(baseUrl, "/").concat(img));
  },
  getThumbnailPathFromTemplate: function getThumbnailPathFromTemplate(env, model) {
    var _a, _b, _c, _d, _e;

    var templateMap = {
      '{bucket}': ((_a = model.env) === null || _a === void 0 ? void 0 : _a.BRIGHTSMITH_S3_BUCKET_PATH) || env.BRIGHTSMITH_S3_BUCKET_PATH,
      '{data}': ((_b = model.env) === null || _b === void 0 ? void 0 : _b.BRIGHTSMITH_S3_DATA_FOLDER) || env.BRIGHTSMITH_S3_DATA_FOLDER,
      '{thumbnails}': ((_c = model.env) === null || _c === void 0 ? void 0 : _c.BRIGHTSMITH_S3_THUMBNAILS_FOLDER) || env.BRIGHTSMITH_S3_THUMBNAILS_FOLDER,
      '{folder}': (_d = model.paths) === null || _d === void 0 ? void 0 : _d.thumbnails
    };
    var template = ((_e = model.env) === null || _e === void 0 ? void 0 : _e.BRIGHTSMITH_THUMBNAIL_PATH_TEMPLATE) || env.BRIGHTSMITH_THUMBNAIL_PATH_TEMPLATE;
    var path = brightsmith_core_1.Util.replaceStringTemplate(template, templateMap);
    return path;
  },
  getThumbnailUrl: function getThumbnailUrl(env, model, img) {
    if (img) {
      var baseUrl = Helper.getThumbnailPathFromTemplate(env, model);
      var thumbnailUrl = Helper.getFullImageUrl(img, baseUrl);
      return thumbnailUrl;
    }
  }
};
exports.default = Helper;